import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, MessagesState} from '@/types/store/states'
import {RawMessage} from '@/types/entity/RawMessage'
import Message from '@/models/Message/Message'
import $store from '@/store'
import {API} from '@/constants'


const store: Module<MessagesState, RootState> = {
  namespaced: true,
  state: {
    messages: {}
  },
  getters: {
    getMessage: state => (data: RawMessage) => {
      if (state.messages[data.id]) {
        state.messages[data.id].setData(data)
      } else {
        Vue.set(state.messages, data.id, new Message(data))
      }
      return state.messages[data.id]
    },
    getMessages: (state, getters) => (items: RawMessage[]) => {
      const result = [];
      for (const item of items) {
        const data = getters.getMessage(item);
        result.push(data)
      }
      return result;
    }
  },
  mutations: {},
  actions: {
    async postMessage (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.postMessage,
        data,
        flag: 'silent'
      }, {root: true})
      return response;
    },
    async getMessages (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.getMessages,
        data,
        flag: 'silent'
      }, {root: true})
      return context.getters.getMessages(response.msgs);
    },
    async listMessages (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.listMessages,
        flag: 'silent',
        data
      }, {root: true})
      return context.getters.getMessages(response.msgs);
    }
  }
}

export default store